import ErrorDisplay from "@/components/ErrorDisplay.vue";
export default {
  components: {
    ErrorDisplay,
  },
  methods: {
    displayMessage(type) {
      if (type == "error") {
        this.$notification.error({
          message: "Error Message",
          description:
            "The system has been failure, please contact the administrator!",
        });
      } else if (type == "error-getdetil") {
        this.$notification.error({
          message: "Error Message",
          description:
            "Could not get the manifest, please contact the administrator!",
        });
      } else if (type == "error-connection") {
        this.$notification.error({
          message: "Error Connection",
          description:
            "Please Check Your Connection Or Contact Your Administrator!",
        });
      } else if (type == "error-connection-refused") {
        this.$notification.error({
          message: "Error Connection",
          description: "Connection Refused, Please Check Your Connection!",
        });
      } else if (type == "error-aktif-project") {
        this.$notification.error({
          message: "Error Message",
          description:
            "Could not get active project, please contact the administrator!",
        });
      } else if (type == "error-saldo") {
        this.$notification.error({
          message: "Error Message",
          description: "Budget balance is not enough!",
        });
      } else if (type == "error-emptyDoc") {
        this.$notification.error({
          message: "Error Message",
          description: "Document Description cannot be empty!",
        });
      } else if (type == "error-emptyDocTemplate") {
        this.$notification.error({
          message: "Error Message",
          description:
            "Could not get the file download, please check your connection!",
        });
      } else if (type == "error-emptyDocFunction") {
        this.$notification.error({
          message: "Error Message",
          description: "Document Function cannot be empty!",
        });
      } else if (type == "error-formatXls") {
        this.$notification.error({
          message: "Error Message",
          description: "The file you selected is not in the .xls/.xlsx format!",
        });
      } else if (type == "error-saldopp") {
        this.$notification.error({
          message: "Error Message",
          description: "Your request exceeds the PP balance!",
        });
      } else if (type == "error-ppproyek") {
        this.$notification.error({
          message: "Error Message",
          description:
            "Make sure your PP is in accordance with the project category!",
        });
      } else if (type == "error-delete-existing") {
        this.$notification.error({
          message: "Error Message",
          description:
            "Failed to clear existing data, please contact the administrator!",
        });
      } else if (type == "error-delete-dtl") {
        this.$notification.error({
          message: "Error Message",
          description: "Failed to removing data, the item still has usage!",
        });
      } else if (type == "error-active-pp") {
        this.$notification.error({
          message: "Error Message",
          description: "No active PP, make sure you have an active PP!",
        });
      } else if (type == "error-upload") {
        this.$notification.error({
          message: "Error Message",
          description: "Upload failed, Please check your file!",
        });
      } else if (type == "error-empty-product") {
        this.$notification.error({
          message: "Error Message",
          description: "Product list cannot empty!",
        });
      } else if (type == "wrong-password") {
        this.$notification.error({
          message: "Wrong Password",
          description: "Please Check Your Password!",
        });
      } else if (type == "404") {
        this.$notification.error({
          message: "Error 404",
          description: "Please Contact Your Administrator!",
        });
      } else if (type == "success") {
        this.$notification.success({
          message: "Successful",
          description: "The data Has Been Processed!",
        });
      } else if (type == "success-save") {
        this.$notification.success({
          message: "Success",
          description: "Data has been saved successfully!",
        });
      } else if (type == "success-edit") {
        this.$notification.success({
          message: "Success",
          description: "Data has been changed successfully!",
        });
      } else if (type == "success-add") {
        this.$notification.success({
          message: "Success",
          description: "Data has been added!",
        });
      } else if (type == "success-del") {
        this.$notification.success({
          message: "Success",
          description: "Data has been deleted!",
        });
      } else if (type == "success-cancel") {
        this.$notification.success({
          message: "Success",
          description: "Data has been canceled!",
        });
      } else if (type == "success-close") {
        this.$notification.success({
          message: "Success",
          description: "Data has been closed!",
        });
      } else if (type == "success-release") {
        this.$notification.success({
          message: "Success",
          description: "Data has been released!",
        });
      } else if (type == "success-upload") {
        this.$notification.success({
          message: "Success",
          description: "data uploaded successfully!",
        });
      } else if (type == "success-send") {
        this.$notification.success({
          message: "Success",
          description: "Data has been sent successfully!",
        });
      } else if (type == "success-close-project") {
        this.$notification.success({
          message: "Success",
          description: "The Project has been closed successfully!",
        });
      } else if (type == "form-warning") {
        this.$notification.warning({
          message: "Warning",
          description: "Please Complete Your Form Input!",
        });
      } else if (type == "data-exist") {
        this.$notification.warning({
          message: "Warning",
          description: "Data Has Been Exist, Choose Another Data!",
        });
      } else if (type == "more-content") {
        this.$notification.warning({
          message: "Warning",
          description: "Please Add more Data!",
        });
      } else if (type == "large-file-2mb") {
        this.$notification.warning({
          message: "Warning",
          description: "File Too Large, max size is 2 MB!",
        });
      } else if (type == "large-file-10mb") {
        this.$notification.warning({
          message: "Warning",
          description: "File Too Large, max size is 10 MB!",
        });
      } else if (type == "large-file-5mb") {
        this.$notification.warning({
          message: "Warning",
          description: "File Too Large, max size is 5 MB!",
        });
      } else if (type == "no-active-sppd") {
        this.$notification.warning({
          message: "Warning",
          description: "No SPPD/S is active, make sure your SPPD/S is active!",
        });
      } else if (type == "no-detil-PP") {
        this.$notification.warning({
          message: "Warning",
          description: "No PP Usage details, please to add it!",
        });
      } else if (type == "no-detil-klaimpp") {
        this.$notification.warning({
          message: "Warning",
          description: "No PP Usage details, please to add it!",
        });
      } else if (type == "no-detil-klaimsppd") {
        this.$notification.warning({
          message: "Warning",
          description: "No PD Usage details, please to add it!",
        });
      } else if (type == "choose-action") {
        this.$notification.warning({
          message: "Warning",
          description: "Please Choose Action First!",
        });
      } else if (type == "denied-manifest") {
        this.$notification.warning({
          message: "Warning",
          description: "The Manifest is denied, you don't have an access!",
        });
      } else if (type == "noPICBOD") {
        this.$notification.warning({
          message: "Warning",
          description:
            "This transaction don't have PIC and Executive, please contact administrator!",
        });
      } else if (type == "form-duplicate") {
        this.$notification.warning({
          message: "Warning",
          description: "the data is already exists, Please Change Your Data!",
        });
      } else if (type == "value-0") {
        this.$notification.warning({
          message: "Warning",
          description: "Cannot insert value 0 !",
        });
      } else if (type == "form-duplicate-contract") {
        this.$notification.warning({
          message: "Warning",
          description:
            "The contract file already exists, delete it before replacing it with a new one!",
        });
      } else if (type == "form-duplicate-contract") {
        this.$notification.warning({
          message: "Warning",
          description:
            "The contract file already exists, delete it before replacing it with a new one!",
        });
      } else if (type == "form-moreData") {
        this.$notification.warning({
          message: "Warning",
          description: "Add At Least One Data!",
        });
      } else if (type == "form-BOD") {
        this.$notification.warning({
          message: "Warning",
          description: "Executive cannot be the same as the project leader!",
        });
      } else if (type == "BadConnection") {
        this.$notification.warning({
          message: "Bad Connection!",
          description:
            "Your data is still being processed, please wait a few more moments",
        });
      } else if (type == "error-only-number") {
        this.$notification.warning({
          message: "Error Message",
          description: "Only Allow Input Numbers!",
        });
      } else if (type == "warning-emptyDoc") {
        this.$notification.warning({
          message: "Warning Message",
          description:
            "Can't close the project cause Document Closing is empty!",
        });
      } else if (type == "warning-valadatorUtang") {
        this.$notification.warning({
          message: "Warning Message",
          description:
            "Can't save this data because debt payment calculation is not yet valid!",
        });
      } else if (type == "warning-valadatordDuration") {
        this.$notification.warning({
          message: "Warning Message",
          description: "End Year must be grather than Start Year!",
        });
      } else if (type == "empty-phurcaselist") {
        this.$notification.warning({
          message: "Warning Message",
          description: "Phurcase List Can't be Empty!",
        });
      }  else if (type == "empty-aplist") {
          this.$notification.warning({
            message: "Warning Message",
            description: "Account Pay List Can't be Empty!",
          });
      }  else if (type == "empty-invoiceList") {
          this.$notification.warning({
            message: "Warning Message",
            description: "Invoice List Can't be Empty!",
          });
      } else if (type == "empty-db") {
        this.$notification.info({
          message: "Information",
          description: "Database are empty, create new data!",
        });
      } else if (type == "choose-again") {
        this.$notification.info({
          message: "Information",
          description: "Reselect the data you need!",
        });
      } else if (type == "error-dp-pp") {
        this.$notification.error({
          message: "Error Message",
          description: "Your downpayment exceeds your estimated value",
        });
      } else if (type == "error-pp-over") {
        this.$notification.error({
          message: "Error Message",
          description:
            "Your Budget Balance is not sufficient for this project code",
        });
      } else if (type == "error-exist_project_code") {
        this.$notification.error({
          message: "Error Message",
          description: "Project code exist",
        });
      } else if (type == "wrong-format") {
        this.$notification.error({
          message: "Error Message",
          description:
            "Wrong input Excel files, Please check whether the data is not empty data or format is correct!",
        });
      } else if (type == "grather0") {
        this.$notification.error({
          message: "Error Message",
          description: "The values must be grather then 0!",
        });
      } else if (type == "empty-evidence") {
        this.$notification.error({
          message: "Error Message",
          description: "Files Evidence of Transfer can't be empty!",
        });
      } else if (type == "grather-1") {
        this.$notification.error({
          message: "Error Message",
          description: "The values must be grather then -1!",
        });
      } else if (type == "grather-remaining") {
        this.$notification.error({
          message: "Error Message",
          description: "The values must be less then remaining plafon values!",
        });
      } else if (type == "grather-total-transaction") {
        this.$notification.error({
          message: "Error Message",
          description: "The values must be less then total transaction values!",
        });
      } else if (type == "emptyPendanaan") {
        this.$notification.warning({
          message: "Warning",
          description: "Financial Remaining Balance must be grather then 0!",
        });
      } else if (type == "over-kredit") {
        this.$notification.warning({
          message: "Warning",
          description: "Credit Cannot Exceed Budget!",
        });
      } else if (type == "Empty-list") {
        this.$notification.warning({
          message: "Warning",
          description: "List has been empty, create new data!",
        });
      } else if (type == "no-active-pp") {
        this.$notification.warning({
          message: "Warning",
          description: "Cannot create Claim PP, make sure your PP is active!",
        });
      } else if (type == "success-release") {
        this.$notification.success({
          message: "Success",
          description: "Account Pay has been Released!",
        });
      } else if (type == "detail-cannot-empty") {
        this.$notification.error({
          message: "Error Message",
          description: "Detail list cannot empty!",
        });
      }


    },
    displayMessageCustom(type, message) {
      if (type == "warning-form-message") {
        this.$notification.error({
          message: "Error Message",
          description:
              message,
        });
      }
    },
    confirmMessage(type) {
      if (type === "confirm-save") {
        this.$confirm({
          title: "Are you sure, you want to save this data?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageReturn", true);
          },
          onCancel() {
            Event.$emit("confirmMessageCancel", true);
          },
        });
      } else if (type === "confirm-save-draft") {
        // Function Bermasalah
        this.$confirm({
          title: "Are you sure, you want to save this data as a draft?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageReturn", true);
          },
          onCancel() {},
        });
      } else if (type === "confirm-draft") {
        this.$confirm({
          title: "Are you sure, you want to save this data as a draft?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmDraftReturn", true);
          },
          onCancel() {},
        });
      } else if (type === "confirm-edit") {
        this.$confirm({
          title: "Are you sure, you want to change this data?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageReturn", true);
          },
          onCancel() {},
        });
      } else if (type === "confirm-update") {
        this.$confirm({
          title: "Are you sure, you want to update this data?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmUpdateReturn", true);
          },
          onCancel() {},
        });
      } else if (type === "confirm-delete") {
        this.$confirm({
          title: "Are you sure, you want to delete this data?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageDelete", true);
          },
          onCancel() {},
        });
      } else if (type === "confirm-close") {
        this.$confirm({
          title: "Are you sure, you want to close this project?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageClose", true);
          },
          onCancel() {},
        });
      }
    },
    displayMessageValue(type, value) {
      if (type == "basic-error") {
        this.$notification.error({
          message: "Error Message",
          description: value,
        });
      } else if (type == "basic-warning") {
        this.$notification.warning({
          message: "Warning Message",
          description: value,
        });
      } else if (type == "basic-info") {
        this.$notification.info({
          message: "Information Message",
          description: value,
        });
      } else if (type == "pp-notenough") {
        this.$notification.error({
          message: "Error Message",
          description: "PP balance value is not enough! the least is " + value,
        });
      } else if (type == "error-nothave-sppd") {
        let descriptions = "";
        if (value.toLowerCase() == "tidak memiliki no sppd") {
          descriptions = "No active SPPD, make sure you have an active SPPD!";
        }
        this.$notification.error({
          message: "Error Message",
          description: descriptions,
        });
      } else if (type == "error-nothave-umpd") {
        let descriptions = "";
        if (value.toLowerCase() == "tidak memiliki no um pd") {
          descriptions = "No active UM PD, make sure you have an active UM PD!";
        }
        this.$notification.error({
          message: "Error Message",
          description: descriptions,
        });
      } else if (type == "error-notif-umpp") {
        let descriptions = "Please Contact Administrator!";
        if (value.toLowerCase() == "user tidak memiliki no um pp") {
          descriptions = "No active UM PP, make sure you have an active UM PP!";
        }
        this.$notification.error({
          message: "Error Message",
          description: descriptions,
        });
      } else if (type == "error-notif-kaskecil") {
        let descriptions = "Please Contact Administrator!";
        if (value == "Tidak Memiliki Detil Pemakaian") {
          descriptions = "No Detail Usage, Please to Add it!";
        }
        this.$notification.error({
          message: "Error Message",
          description: descriptions,
        });
      } else if (type == "error") {
        this.$notification.error({
          message: "Error Message",
          description: <ErrorDisplay valueError={value} />,
        });
      } else if (type == "success-copy-resi") {
        this.$success({
          title: "Success copy resi " + value,
        });
      } else if (type == "delete-cancel") {
        this.$notification.error({
          message: "Error Message",
          description: "Cannot delete, there must be credit data",
        });
      } else if (type == "limit-lap") {
        this.$notification.error({
          message: "Error Message",
          description: "Your report has exceeded the limit of " + value,
        });
      } else if (type == "limit-anggaran") {
        this.$notification.error({
          message: "Error Message",
          description: "The values has exceeded the limit of " + value,
        });
      } else if (type == "limit-bawah-anggaran") {
        this.$notification.error({
          message: "Error Message",
          description: "change in value must be more than " + value + "!",
        });
      } else if (type == "limit-pemakaian-anggaran") {
        this.$notification.error({
          message: "Error Message",
          description: "The budget has been used as much as " + value + "!",
        });
      } else if (type == "limit-userFor") {
        this.$notification.error({
          message: "Error Message",
          description:
            "The content values must be one item if category choice is Payment Instructtion! ",
        });
      } else if (type == "notify") {
        this.$notification.info({
          message: "Notification",
          description: "Your have new notification from " + value.tlc_from,
        });
      } else if (type == "update-item") {
        this.$notification.success({
          message: "Success",
          description: value + " Has Been Updated!",
        });
      } else if (type == "successCancel") {
        this.$notification.success({
          message: "Success",
          description: value,
        });
      } else if (type == "successClose") {
        this.$notification.success({
          message: "Success",
          description: value,
        });
      } else if (type == "error-other") {
        this.$notification.error({
          message: "Error Message",
          description: value,
        });
      } else if (type == "success-other") {
        this.$notification.success({
          message: "Success Message",
          description: value,
        });
      }
    },
    confirmMessageValue(type, value, table) {
      if (type == "confirm-delete") {
        this.$confirm({
          title: "Are you sure, you want to delete this data?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageDelete", value);
          },
          onCancel() {},
        });
      } else if (type == "confirm-delete-clear") {
        this.$confirm({
          title: "Are you sure, you want to delete this data?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageDeleteClear", value);
          },
          onCancel() {},
        });
      } else if (type == "confirm-add-detil") {
        this.$confirm({
          title: "Are you sure, you want to add this data?",
          content: "",
          okText: "Yes",
          okType: "primary",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageAddDetil", value);
          },
          onCancel() {},
        });
      } else if (type == "confirm-delete-detil") {
        this.$confirm({
          title: "Are you sure, you want to delete this data?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageDeleteDetil", value);
          },
          onCancel() {},
        });
      } else if (type == "confirm-add-detil-po") {
        this.$confirm({
          title: "Are you sure, you want to add this data?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageAddDetilPo", value, table);
          },
          onCancel() {},
        });
      } else if (type == "confirm-edit-detil") {
        this.$confirm({
          title: "Are you sure, you want to change this data?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("confirmMessageEditDetil", value);
          },
          onCancel() {
            Event.$emit("confirmMessageCancelEditDetil");
          },
        });
      } else if (type == "confirm-cancel") {
        this.$confirm({
          title: "Are you sure, you want to cancel this transaction?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("handleCancel", value);
          },
          onCancel() {},
        });
      } else if (type == "confirm-close") {
        this.$confirm({
          title: "Are you sure, you want to close this transaction?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("handleClose", value);
          },
          onCancel() {},
        });
      } else if (type == "confirm-replace") {
        this.$confirm({
          title: "Data is Exist, Are you sure to replace it?",
          content: "",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            Event.$emit("handleReplace", value);
          },
          onCancel() {},
        });
      }
    },
  },
};
